<template>
  <NodeViewWrapper>
    <div data-type="image-block">
      <div contenteditable="false">
        <img
          :class="wrapperClassName"
          :data-load-failed="props.node.attrs['data-load-failed']"
          :data-uid="props.node.attrs['data-uid']"
          :src="imgSrc"
          :style="{ 'max-width': props.node.attrs.width }"
          alt=""
          class="ibv-Image"
          @click="onClick"
          @error="onImageError"
        />
      </div>
    </div>
  </NodeViewWrapper>
</template>

<script setup>
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import { computed, onMounted, ref, watch } from 'vue'

const props = defineProps(nodeViewProps)

const wrapperClassName = computed(() => {
  const align = props.node.attrs.align
  return align && `ibv-Image-align-${align}`
})

const onClick = () => {
  if (props.editor && props.getPos) {
    props.editor.commands.setNodeSelection(props.getPos())
  }
}

const imgSrc = ref(props.node.attrs.src)

const FALLBACK_IMG = 'https://s3-oboard-public-static.s3.eu-central-1.amazonaws.com/img/IMG.png'
const onImageError = () => {
  imgSrc.value = FALLBACK_IMG
  props.updateAttributes({ 'data-load-failed': true })
}

onMounted(() => {
  imgSrc.value = props.node.attrs.src
})

watch(
  () => props.node.attrs.src,
  () => {
    imgSrc.value = props.node.attrs.src
  }
)
</script>

<style lang="scss" scoped>
.ibv-Image {
  max-height: 300px;
  max-width: 100%;
  object-fit: cover;
  display: flex;
}

.ibv-Image-align {
  &-left {
    margin-inline: 0 auto;
  }
  &-right {
    margin-inline: auto 0;
  }
  &-center {
    margin-inline: auto;
  }
}
</style>
